import CircularProgress from '@mui/material/CircularProgress'

interface LoadingScreenProps {
  message?: string
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <div className="flex flex-col items-center gap-4">
        <CircularProgress size={40} sx={{ color: '#DA7756' }} />
        <p className="text-sm text-warm">{message}</p>
      </div>
    </div>
  )
}
